export default "__VITE_ASSET__y4J5zkai__"